import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { ShippingCharge, ShippingChargesCriteria } from '../models';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { ShippingChargesTableRowComponent } from './shipping-charges-table-row.component';
//import { Store } from '@ngrx/store';

@Component({
  selector: 'opus-shipping-charges-table',
  templateUrl: './shipping-charges-table.component.html'
})
export class ShippingChargesTableComponent {
  @Input() criteria: ShippingChargesCriteria;
  @Input() shippingCharges$: Observable<ShippingCharge[]>;
  @Input() isEditing: boolean;

  form: FormGroup;

  constructor(private fb: FormBuilder) {
    console.log('ShippingChargesTableComponent()...');

    this.form = this.fb.group({
      shippingChargesData: this.fb.array([])
    });
  }

  ngOnInit() {
    console.log('ShippingChargesTableComponent.ngOnInit()...');

    this.createForm();
  }

  ngOnDestroy(): void {}

  createForm() {
    const shippingChargesData = this.fb.array([]);

    this.shippingCharges$.forEach(i => {
      if (i != null) {
        for (let ind = 0; ind < i.length; ind++) {
          const itm = ShippingChargesTableRowComponent.BuildItem(i[ind]);
          shippingChargesData.push(itm);
        }
        this.form = this.fb.group({
          shippingChargesData
        });
      }
    });
  }

  getChanges(): FormGroup[] {
    const changed = (this.form.controls.shippingChargesData as FormArray).controls.filter(g => g.dirty);

    console.log('ShippingChargesTableComponent.getChanges(): ', changed);

    return changed as FormGroup[];
  }
}
